import QueueableRequest from './QueueableRequest';

export default class SvgRequest extends QueueableRequest {
  constructor(url, responseDataType) {
    super(url, { responseDataType, camelizeResponse: false });
  }
}
